import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import EstateTypeLang from '/@/modules/estate/services/EstateTypeLang';

export class ClearEstateContactRelationshipType extends Enum {
  key!: string | null;
  value!: string;
  displayValue!: string;

  static BIOLOGICAL: ClearEstateContactRelationshipType = {
    key: 'biological',
    get value(): string {
      return Lang.t('contact.biological-estatename-child', {
        estateName: EstateTypeLang.estate?.contact.fullName ?? 'the deceased'
      });
    },
    get displayValue(): string {
      return Lang.t('contact.biological-child');
    }
  };

  static ADOPTED: ClearEstateContactRelationshipType = {
    key: 'adopted',
    get value(): string {
      return Lang.t('contact.legally-estatename-child', {
        estateName: EstateTypeLang.estate?.contact.fullName ?? 'the deceased'
      });
    },
    get displayValue(): string {
      return Lang.t('contact.legally-adopted-child');
    }
  };

  static OTHER: ClearEstateContactRelationshipType = {
    key: null,
    get value(): string {
      return Lang.t('contact.other-explain');
    },
    get displayValue(): string {
      return Lang.t('contact.other');
    }
  };
}
